const getters = {
	sidebar: state => state.app.sidebar,
	visitedViews: state => state.app.visitedViews,
	token: state => state.user.token,
	avatar: state => state.user.avatar,
	name: state => state.user.name,
	introduction: state => state.user.introduction,
	status: state => state.user.status,
	roles: state => state.user.roles,
	menus: state => state.user.menus,
	elements: state => state.user.elements,
	setting: state => state.user.setting,
	permission_routers: state => state.permission.routers,
	addRouters: state => state.permission.addRouters,
	permissionMenus: state => state.user.permissionMenus,
  permissionButtons: state => state.user.permissionButtons,
	username: state => state.user.username,
	rolecode: state => state.user.rolecode,
	id: state => state.user.id
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js